/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Feed16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.4 12.8a.6.6 0 010 1.2H2.6a.6.6 0 010-1.2h10.8zm0-2.4a.6.6 0 010 1.2H2.6a.6.6 0 010-1.2h10.8zM13.333 2c.369 0 .667.298.667.667v5.866a.667.667 0 01-.667.667H2.667A.667.667 0 012 8.533V2.667C2 2.298 2.298 2 2.667 2h10.666z"
        />
    </AccessibleSVG>
);

export default Feed16;
